module.exports = __webpack_public_path__ + "static/media/sam-praha.596ab25f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/sam-praha.jpg
// module id = 5743
// module chunks = 0